import { API_URL } from '../constants/index'
import { getRequest, postRequest, deleteRequest, getInvoice2ID } from './api'

export async function list(size, index, containsValues, orderByValues, invoiceID) {
  const url = new URL(`${API_URL}invoice2Item`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  if (size !== null && size !== undefined) {
    searchParams.append('size', parseInt(size, 10) || 15)
  }

  if (index !== null && index !== undefined) {
    searchParams.append('index', parseInt(index, 10) || 0)
  }

  if (containsValues !== null && containsValues !== undefined) {
    searchParams.append('containsValues', containsValues)
  }

  if (orderByValues !== null && orderByValues !== undefined) {
    searchParams.append('orderByValues', orderByValues)
  }

  if (
    containsValues !== null &&
    containsValues !== undefined &&
    !containsValues.includes('InvoiceID')
  ) {
    searchParams.append('InvoiceID', getInvoice2ID())
  }

  if (invoiceID !== null && invoiceID !== undefined) {
    searchParams.append('invoiceID', invoiceID)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function find(id) {
  return getRequest(`${API_URL}invoice2Item/${id}`)
}

export async function save(values) {
  return postRequest(`${API_URL}invoice2Item`, values)
}

export function remove(id) {
  return deleteRequest(`${API_URL}invoice2Item/${id}`)
}
